import type { NextSeoProps } from 'next-seo';

export type HubPageOpenGraph = {
  domain: string;
  pageName: string;
  title: string;
  description: string;
  image: string;
};

export function generateOpenGraph(
  props: HubPageOpenGraph,
): NextSeoProps['openGraph'] {
  const url = `${props.domain}/${props.pageName}`;
  const title = props.title || '';
  const description = props.description || '';
  const images = [
    { url: props.image, propswidth: 1200, height: 600, alt: props.title },
  ];

  return {
    url,
    title,
    description,
    images,
  };
}
